import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100%;
  margin: 50px auto;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: Roboto, sans-serif; 
`;

export const Header = styled.h3`
  text-align: center;
  margin-bottom: 16px;
  color: #333;
`;

export const MessageList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 16px;
`;

export const MessageItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 12px;
  }

  div {
    flex: 1;

    strong {
      color: #333;
      display: block;
      margin-bottom: 4px;
    }

    p {
      margin: 0;
      color: #555;
    }

    small {
      color: #999;
      font-size: 12px;
    }
  }
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const Input = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

export const Button = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;
